import { t } from "i18next";
import { observer } from "mobx-react-lite";
import { translateAction } from "../../../../../../../locales/i18n";
import { useRootStore } from "../../../../../../../stores/hooks";
import {
  addEmptyValueIfNeeded,
  findRecordValue,
  getInputLabel,
} from "../../../../../ActivityGrid/ActivityGrid.helpers";
import { ActionError } from "../../../ActionError/ActionError";
import { ActivityDetailsGroup } from "../../../ActivityDetailsGroup/ActivityDetailsGroup";
import { ActivityDetailsItem } from "../../../ActivityDetailsItem/ActivityDetailsItem";
import { ActivityDetailsTriggerGroup } from "../../../ActivityDetailsTriggerGroup/ActivityDetailsTriggerGroup";
import { useActionDetails } from "../../hooks/useActionDetails";
import type { ActionGroupProps } from "../../types";

export const FindLoopingRecordsGroup = observer<ActionGroupProps>(
  ({ action, onDetailsClick, recordJobData }) => {
    const { status, errorMessage, selectedActionFallback, selectedAction } =
      useActionDetails(action);
    const { automations, jobDetails } = useRootStore();

    const records =
      recordJobData?.outputData?.recordList?.recordList !== undefined
        ? recordJobData.outputData.recordList.recordList.records
        : recordJobData?.record
          ? [recordJobData.record]
          : [];

    let recordsCount = 0;

    if (action?.recordListCount !== undefined) {
      recordsCount = action.recordListCount;
    }
    if (action.recordList?.recordList !== undefined) {
      recordsCount = action.recordList.recordList.records.length;
    }

    return (
      <ActivityDetailsGroup
        label={
          selectedAction !== undefined ? translateAction(selectedAction) : ""
        }
        subLabel={t("job-list.records-found", {
          count: recordsCount,
        })}
        status={status}
        onClick={onDetailsClick}
      >
        {status === "is_error" && <ActionError errorMessage={errorMessage} />}
        {records.map((record, index) => {
          return (
            <ActivityDetailsTriggerGroup
              key={index}
              title={`Record ${index + 1}`}
              onClick={onDetailsClick}
            >
              <ActivityDetailsItem
                label={getInputLabel(
                  {
                    inputId: "application_id",
                  },
                  jobDetails,
                  action,
                  automations.candidate.allActions,
                  selectedActionFallback,
                  index,
                )}
              >
                {findRecordValue("application_id", record)}
              </ActivityDetailsItem>
              <ActivityDetailsItem
                label={getInputLabel(
                  {
                    inputId: "record_id",
                  },
                  jobDetails,
                  action,
                  automations.candidate.allActions,
                  selectedActionFallback,
                  index,
                )}
              >
                {findRecordValue("record_id", record)}
              </ActivityDetailsItem>
              <ActivityDetailsItem label={t("job-list.record-name")}>
                {addEmptyValueIfNeeded(findRecordValue("title", record))}
              </ActivityDetailsItem>
            </ActivityDetailsTriggerGroup>
          );
        })}
      </ActivityDetailsGroup>
    );
  },
);
